__webpack_require__.p = "/acquisition-translate-hapi-elements/onboarding/";